import { parseIsoStrict, teilnahmeEnde } from './teilnahmeEnde'

export type MaxDauer = { wert: number; einheit: 'Wochen' | 'Monate' }

const MAX_DAUER_RE = /^(\d+)\s*(wochen?|monate?)\b/i

export function parseMaxDauer(raw: string): MaxDauer | null {
  const s = raw.trim()
  if (!s) return null
  const m = MAX_DAUER_RE.exec(s)
  if (!m) return null
  const wert = parseInt(m[1], 10)
  if (!(wert > 0)) return null
  const einheit: MaxDauer['einheit'] = m[2].toLowerCase().startsWith('wo') ? "Wochen" : "Monate"
  return { wert, einheit }
}

export function formatMaxDauer(d: MaxDauer): string {
  return `${d.wert} ${d.einheit}`
}

export function maxEndeDatum(beginnIso: string, dauer: MaxDauer | null): string | null {
  if (!dauer) return null
  const beginn = parseIsoStrict(beginnIso)
  if (!beginn) return null

  if (dauer.einheit === 'Wochen') return teilnahmeEnde(beginnIso, dauer.wert)

  const y = beginn.getFullYear()
  const mo = beginn.getMonth()
  const d = beginn.getDate()
  const targetMonthFirst = new Date(y, mo + dauer.wert, 1)
  const daysInTargetMonth = new Date(
    targetMonthFirst.getFullYear(),
    targetMonthFirst.getMonth() + 1,
    0,
  ).getDate()

  let ende: Date
  if (d > daysInTargetMonth) {
    ende = new Date(targetMonthFirst.getFullYear(), targetMonthFirst.getMonth(), daysInTargetMonth)
  } else {
    const target = new Date(targetMonthFirst.getFullYear(), targetMonthFirst.getMonth(), d)
    ende = new Date(target.getFullYear(), target.getMonth(), target.getDate() - 1)
  }
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${ende.getFullYear()}-${pad(ende.getMonth() + 1)}-${pad(ende.getDate())}`
}
